import { Spin } from 'antd';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { axiosInstance, config } from '../pages/config';
import secureLocalStorage from 'react-secure-storage';
import '../../assets/styles/booking.css';
import BookingHeader from '../pages/Booking/BookingHeader';

const PaymentSuccess = () => {
    const [loading, setLoading] = useState(false);
    const [payment_data, setPaymentData] = useState(null);

    const { pay_status } = useParams()
    const navigate = useNavigate()

    const possible_status = ['success', 'failed'];
    const queryParams = new URLSearchParams(window.location.search);
    const session_id = queryParams.get("session_id");

    const lastBooking = (() => {
        try {
            const raw = localStorage.getItem('last_booking');
            return raw ? JSON.parse(raw) : null;
        } catch { return null; }
    })();

    useEffect(() => {
        if (!possible_status.includes(pay_status)) {
            navigate(config.appUrl)
        }
    }, [])

    useEffect(() => {
        async function getPaymentDetails() {
            try {
                setLoading(true)
                const response = await axiosInstance.post("/enrollment/details", { session_id })
                if (response.data.data) {
                    setPaymentData({
                        ...response.data.data,
                        amount: `£ ${response.data.data?.amount}`
                    } || {})
                    secureLocalStorage.removeItem('temp_details')
                } else {
                    navigate(`${config.appUrl}payment/failed`)
                }
            } catch (error) {
                console.log(error)
                navigate(`${config.appUrl}payment/failed`)
            } finally {
                setLoading(false)
            }
        }

        if (session_id) getPaymentDetails()
    }, [session_id])

    return (
        <div className="booking-page-wrap">
            <BookingHeader title="" showBack={false} />

            <div className="booking-success-container">
                {loading === false ? (
                    pay_status === 'success' ? (
                        <div className="booking-success-card">
                            {/* Green check icon */}
                            <div className="booking-success-icon">
                                <i className="bi bi-check-lg"></i>
                            </div>

                            <h2 className="booking-success-title">Booking Confirmed!</h2>
                            <p className="booking-success-text">
                                A confirmation email has been sent to your email address with the details of your lessons.
                            </p>

                            {/* Booking Details */}
                            {payment_data && (
                                <div className="booking-success-details">
                                    <h6>Booking Details</h6>
                                    <div className="booking-success-details-grid">
                                        {payment_data.bookingdate && (
                                            <div className="booking-success-detail-item">
                                                <i className="bi bi-calendar3"></i>
                                                <div>
                                                    <span className="booking-success-detail-label">Date</span>
                                                    <span className="booking-success-detail-value">{payment_data.bookingdate}</span>
                                                </div>
                                            </div>
                                        )}
                                        {payment_data.bookingtime && (
                                            <div className="booking-success-detail-item">
                                                <i className="bi bi-clock"></i>
                                                <div>
                                                    <span className="booking-success-detail-label">Time</span>
                                                    <span className="booking-success-detail-value">{payment_data.bookingtime}</span>
                                                </div>
                                            </div>
                                        )}
                                        {payment_data.instructor_name && (
                                            <div className="booking-success-detail-item">
                                                <i className="bi bi-person"></i>
                                                <div>
                                                    <span className="booking-success-detail-label">Instructor</span>
                                                    <span className="booking-success-detail-value">{payment_data.instructor_name}</span>
                                                </div>
                                            </div>
                                        )}
                                        {payment_data.amount && (
                                            <div className="booking-success-detail-item">
                                                <i className="bi bi-credit-card"></i>
                                                <div>
                                                    <span className="booking-success-detail-label">Total Paid</span>
                                                    <span className="booking-success-detail-value booking-success-price">{payment_data.amount}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* Fallback details from last_booking if API data is limited */}
                            {!payment_data && lastBooking && (
                                <div className="booking-success-details">
                                    <h6>Booking Details</h6>
                                    <div className="booking-success-details-grid">
                                        <div className="booking-success-detail-item">
                                            <i className="bi bi-calendar3"></i>
                                            <div>
                                                <span className="booking-success-detail-label">Date</span>
                                                <span className="booking-success-detail-value">{lastBooking.date}</span>
                                            </div>
                                        </div>
                                        <div className="booking-success-detail-item">
                                            <i className="bi bi-clock"></i>
                                            <div>
                                                <span className="booking-success-detail-label">Time</span>
                                                <span className="booking-success-detail-value">{lastBooking.time}</span>
                                            </div>
                                        </div>
                                        <div className="booking-success-detail-item">
                                            <i className="bi bi-person"></i>
                                            <div>
                                                <span className="booking-success-detail-label">Instructor</span>
                                                <span className="booking-success-detail-value">{lastBooking.instructorName}</span>
                                            </div>
                                        </div>
                                        <div className="booking-success-detail-item">
                                            <i className="bi bi-credit-card"></i>
                                            <div>
                                                <span className="booking-success-detail-label">Total Paid</span>
                                                <span className="booking-success-detail-value booking-success-price">{lastBooking.amount}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Action buttons */}
                            <div className="booking-success-actions">
                                <Link to={`${config.appUrl}booking-details`} className="booking-success-btn-primary">
                                    VIEW MY BOOKING
                                </Link>
                                <Link to={`${config.appUrl}`} className="booking-success-btn-secondary">
                                    BACK TO HOME
                                </Link>
                            </div>
                        </div>
                    ) : (
                        <div className="booking-success-card">
                            <div className="booking-success-icon failed">
                                <i className="bi bi-x-lg"></i>
                            </div>
                            <h2 className="booking-success-title">Payment Failed</h2>
                            <p className="booking-success-text">
                                We're sorry, but your payment could not be processed at this time. Please try again or use a different payment method.
                            </p>
                            <div className="booking-success-actions">
                                <Link to={`${config.appUrl}book-a-lesson`} className="booking-success-btn-primary">
                                    TRY AGAIN
                                </Link>
                                <Link to={`${config.appUrl}`} className="booking-success-btn-secondary">
                                    BACK TO HOME
                                </Link>
                            </div>
                        </div>
                    )
                ) : (
                    <div className="booking-success-loading">
                        <Spin />
                        <h3>Processing your payment...</h3>
                        <p>Please wait a moment while we confirm your booking.</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default PaymentSuccess
